import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { PutComponentsRequestRuntype, PutComponentsResponseRuntype } from './componentBackendTypes';

export const componentEndpoints = {
    'PUT /components': endpoint({
        description: 'Upsert components (component importer v2)',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: PutComponentsRequestRuntype,
        responseBody: PutComponentsResponseRuntype,
    }),
};
